module.exports = __webpack_public_path__ + "images/data-camp-img2.jpg";